import React from "react";
import { CardContent } from "../../Components/UI/card";
import { cn } from "../../Lib/Cn";

const NoDataCard = ({ Icon, title, desc, staticIcon="", className="", onClick }) => {
  return (
    <CardContent
      className={cn('p-4 bg-sahi-disable cursor-pointer h-full border border-sahi-border-color m-3 md:m-0 hover:bg-gray-50 sahi-radius md:bg-sahi-white md:!max-h-[150px] md:h-[100px]', 
          className)}
      onClick={onClick}
    >
      <div className="h-full flex items-start justify-start">
        <div className="flex items-start space-x-4">

          {Icon && (
            <Icon className="h-8 w-8 text-sahi-grey flex-shrink-0 mt-1" />
          )}
          {staticIcon && (
            <span className="text-sahi-grey text-4xl block">{staticIcon}</span>
          )}

          <div className="text-left">
            <p className="text-xs text-gray-400 mb-1">{title}</p>
            <p className="text-sm font-medium">{desc}</p>
          </div>
        </div>
      </div>
    </CardContent>
  );
};

export default NoDataCard;
